// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListBusinessUnitsQueryVariables = Types.Exact<{
  pageNumber: Types.InputMaybe<Types.Scalars['Int']['input']>;
  pageSize: Types.InputMaybe<Types.Scalars['Int']['input']>;
  enabled: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  keyword: Types.InputMaybe<Types.Scalars['String']['input']>;
  hasEmployees?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  excludeIds: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  companyId: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type ListBusinessUnitsQuery = { __typename?: 'Query' } & {
  listBusinessUnits: { __typename?: 'ListBusinessUnits' } & Pick<Types.ListBusinessUnits, 'totalCount'> & {
      items: Array<
        { __typename?: 'BusinessUnit' } & Pick<
          Types.BusinessUnit,
          'id' | 'name' | 'enabled' | 'createdAt' | 'updatedAt' | 'divisionId'
        > & {
            division: { __typename?: 'Division' } & Pick<Types.Division, 'id' | 'name'>;
            valueDeliveredDepartment: Types.Maybe<
              { __typename?: 'EpmMasterVdd' } & Pick<Types.EpmMasterVdd, 'id' | 'name'>
            >;
            defaultEpmMasterRoleType: Types.Maybe<
              { __typename?: 'EpmMasterRoleType' } & Pick<Types.EpmMasterRoleType, 'id' | 'name'>
            >;
            definitions: Array<
              { __typename?: 'DefinitionItem' } & Pick<Types.DefinitionItem, 'languageCode' | 'displayName' | 'content'>
            >;
          }
      >;
    };
};

export const ListBusinessUnitsDocument = /*#__PURE__*/ gql`
    query listBusinessUnits($pageNumber: Int, $pageSize: Int, $enabled: Boolean, $keyword: String, $hasEmployees: Boolean = null, $excludeIds: [ID!], $companyId: ID) {
  listBusinessUnits(
    filter: {pageNumber: $pageNumber, pageSize: $pageSize, enabled: $enabled, keyword: $keyword, hasEmployees: $hasEmployees, excludeIds: $excludeIds, companyId: $companyId}
  ) {
    items {
      id
      name
      enabled
      createdAt
      updatedAt
      division {
        id
        name
      }
      divisionId
      valueDeliveredDepartment {
        id
        name
      }
      defaultEpmMasterRoleType {
        id
        name
      }
      definitions {
        languageCode
        displayName
        content
      }
    }
    totalCount
  }
}
    `;

/**
 * __useListBusinessUnitsQuery__
 *
 * To run a query within a React component, call `useListBusinessUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBusinessUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBusinessUnitsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      enabled: // value for 'enabled'
 *      keyword: // value for 'keyword'
 *      hasEmployees: // value for 'hasEmployees'
 *      excludeIds: // value for 'excludeIds'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useListBusinessUnitsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListBusinessUnitsQuery, ListBusinessUnitsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListBusinessUnitsQuery, ListBusinessUnitsQueryVariables>(ListBusinessUnitsDocument, options);
}
export function useListBusinessUnitsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListBusinessUnitsQuery, ListBusinessUnitsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListBusinessUnitsQuery, ListBusinessUnitsQueryVariables>(
    ListBusinessUnitsDocument,
    options,
  );
}
// @ts-expect-error
export function useListBusinessUnitsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListBusinessUnitsQuery, ListBusinessUnitsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListBusinessUnitsQuery, ListBusinessUnitsQueryVariables>;
export function useListBusinessUnitsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListBusinessUnitsQuery, ListBusinessUnitsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListBusinessUnitsQuery | undefined, ListBusinessUnitsQueryVariables>;
export function useListBusinessUnitsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListBusinessUnitsQuery, ListBusinessUnitsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListBusinessUnitsQuery, ListBusinessUnitsQueryVariables>(
    ListBusinessUnitsDocument,
    options,
  );
}
export type ListBusinessUnitsQueryHookResult = ReturnType<typeof useListBusinessUnitsQuery>;
export type ListBusinessUnitsLazyQueryHookResult = ReturnType<typeof useListBusinessUnitsLazyQuery>;
export type ListBusinessUnitsSuspenseQueryHookResult = ReturnType<typeof useListBusinessUnitsSuspenseQuery>;
